module.exports = __webpack_public_path__ + "static/img/apollo_logo.fc7b2a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apollo_logo.png
// module id = /0pv
// module chunks = 0